import { Injectable, Inject} from '@angular/core';

export  class OtherPolicyDO{
 
 	public  id:Number;

	public  provider:String;

	public  policyNum:String;

	public sumInsured: DoubleRange;
	
	public term: Number;

	public  premium:DoubleRange;

	public  commencementDt:Date;

	public  expiryDt:Date;

	public  statusCd:String;

	public  getId():Number {
		return this.id;
	}

	public setId( id:Number) {
		this.id = id;
	}

	public  getProvider():String {
		return this.provider;
	}

	public setProvider( provider:String) {
		this.provider = provider;
	}

	public getPolicyNum():String {
		return this.policyNum;
	}

	public setPolicyNum(policyNum:String) {
		this.policyNum = policyNum;
	}

	public  getSumInsured():DoubleRange {
		return this.sumInsured;
	}

	public setSumInsured(sumInsured:DoubleRange) {
		this.sumInsured = sumInsured;
	}

	public getPremium():DoubleRange {
		return this.premium;
	}

	public setPremium(premium:DoubleRange) {
		this.premium = premium;
	}

	public getCommencementDt():Date {
		return this.commencementDt;
	}

	public setCommencementDt(commencementDt:Date) {
		this.commencementDt = commencementDt;
	}

	public getExpiryDt():Date {
		return this.expiryDt;
	}

	public setExpiryDt(expiryDt:Date) {
		this.expiryDt = expiryDt;
	}

	public getStatusCd():String {
		return this.statusCd;
	}

	public setStatusCd(statusCd:String) {
		this.statusCd = statusCd;
	}

}